import { render, staticRenderFns } from "./Adm_catalogo.vue?vue&type=template&id=29d02b0c"
import script from "./Adm_catalogo.vue?vue&type=script&lang=js"
export * from "./Adm_catalogo.vue?vue&type=script&lang=js"
import style0 from "./Adm_catalogo.vue?vue&type=style&index=0&id=29d02b0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports